import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const FeatureAccessContext = createContext(null);

export function FeatureAccessProvider({ children }) {
  const { user } = useAuth();
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setAccess(null);
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.get("/billing/feature-access");
      setAccess(data);
    } catch {
      setAccess(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ access, loading, refresh }), [access, loading, refresh]);
  return <FeatureAccessContext.Provider value={value}>{children}</FeatureAccessContext.Provider>;
}

export function useFeatureAccess() {
  return useContext(FeatureAccessContext) || { access: null, loading: false, refresh: () => {} };
}
